var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.490933 6.337C0.490426 6.1876 0.523397 6.03999 0.587426 5.90502C0.651455 5.77004 0.744914 5.65112 0.860934 5.557L6.86093 0.727C7.03987 0.579918 7.26431 0.499512 7.49593 0.499512C7.72756 0.499512 7.952 0.579918 8.13093 0.727L14.1309 5.727C14.3352 5.89674 14.4636 6.14065 14.488 6.40508C14.5123 6.6695 14.4307 6.93278 14.2609 7.137C14.0912 7.34122 13.8473 7.46964 13.5829 7.49402C13.3184 7.5184 13.0552 7.43674 12.8509 7.267L7.49093 2.797L2.13093 7.117C1.98415 7.23928 1.80541 7.31696 1.61586 7.34084C1.42631 7.36472 1.23389 7.3338 1.06136 7.25175C0.888831 7.16969 0.74342 7.03993 0.642329 6.87782C0.541239 6.71571 0.488702 6.52803 0.490933 6.337Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.f573be273a06ea495bb89623b880e8a5.svg";
export { ForwardRef as ReactComponent };